import { Link } from "react-router-dom";
import styled from "styled-components";
import { imageOnLoadHandler, imageOnErrorHandler } from "../../utils/imgLoader";

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  a {
    color: #0f0f0f;
  }
  img {
    height: 300px;
    width: 100%;
    object-fit: cover;
    object-position: center 0;
  }
`;

const GalleryItem = ({ item }) => {
  // const imageURL = `https://gateway.pinata.cloud/ipfs/QmSj9wEMfCEUTTyTxzDd1ayfQNo8aBQgfVwcwaB6ACKQv3/${item.id}.png`;

  const imageURL =
    item.id === "ercan"
      ? item.imageURL
      : `https://bafybeigfxvhuht4tentzgl2r64ipyadskl3vfc544bci2mejd5zby23ugy.ipfs.infura-ipfs.io/${item.id}.png`;

  return (
    <ItemContainer key={item.id}>
      <Link
        to={`/nft/${item.id}`}
        state={{ imageURL, title: item.name, description: "TEST DESC" }}>
        <img
          src={imageURL}
          alt={item.name}
          onLoad={imageOnLoadHandler}
          onError={imageOnErrorHandler}
        />
        <div className="paragraph large">{item.name}</div>
      </Link>
    </ItemContainer>
  );
};

export default GalleryItem;
